/**
 * A best-effort step that mustn't hold up what waits on it: it settles as
 * `step` does, or rejects once `ms` have passed. The step itself carries on;
 * only the wait stops.
 */
export function settleWithin<T> (step: Promise<T>, ms: number, what: string): Promise<T> {
	let timer: ReturnType<typeof setTimeout> | null = null;
	const late = new Promise<never>((_, reject) => {
		timer = setTimeout(() => reject(new Error(`${what} took longer than ${ms} ms`)), ms);
	});
	return Promise.race([step, late]).finally(() => {
		if (timer) clearTimeout(timer);
	});
}
